import { render, staticRenderFns } from "./RemediationApplications.vue?vue&type=template&id=a33d9f00"
import script from "./RemediationApplications.vue?vue&type=script&lang=js"
export * from "./RemediationApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports